import { useState, useEffect } from 'react'
import http from 'http'

const PathImage = ( {
  identity,
  groupName,
  color
} ) => {
  const [ image, setImage ] = useState()

  useEffect( () => {

    http( {
      method: 'GET',
      url: `/track/${ identity }/render`,
      params: {
        __background_color: 'transparent',
        __point_color: color
      }
    } )
      .then( ( { data } ) => {
        setImage( data.svg )
      } )

  }, [] )


  if ( ! image )
    return null
 
  return <div className="path-container" dangerouslySetInnerHTML={ { __html: image } } />
}

export default PathImage
